import React, { ReactElement } from 'react';
import { Divider, Stack, StackProps } from '@mui/material';

type StakingStatsProps = Omit<StackProps, 'direction' | 'spacing' | 'divider'>;

export function StakingStats({
  ...restProps
}: StakingStatsProps): ReactElement {
  return (
    <Stack
      {...restProps}
      direction="row"
      divider={<Divider flexItem orientation="vertical" />}
      spacing={4.25}
    />
  );
}
